module.exports = __webpack_public_path__ + "img/about.96d76a56.svg";